import { render, staticRenderFns } from "./SwpieEdit.vue?vue&type=template&id=59ecd0ca"
import script from "./SwpieEdit.vue?vue&type=script&lang=js"
export * from "./SwpieEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports